// Lazy-loaded MoveNet pose detector. Returns a detector instance that maps to COCO-17 keypoints.
// Used by ChallengeDetail.jsx live-rep overlay.

let detectorPromise = null;

export async function getDetector() {
    if (detectorPromise) return detectorPromise;
    detectorPromise = (async () => {
        const tf = await import("@tensorflow/tfjs");
        await tf.ready();
        // Use WebGL backend for performance; fall back to CPU automatically.
        try {
            await tf.setBackend("webgl");
        } catch (_) {
            await tf.setBackend("cpu");
        }
        const poseDetection = await import("@tensorflow-models/pose-detection");
        const model = poseDetection.SupportedModels.MoveNet;
        const detector = await poseDetection.createDetector(model, {
            modelType: poseDetection.movenet.modelType.SINGLEPOSE_LIGHTNING,
        });
        return detector;
    })();
    return detectorPromise;
}

export async function estimatePose(video) {
    if (!video || video.readyState < 2) return null;
    const detector = await getDetector();
    const poses = await detector.estimatePoses(video, { flipHorizontal: false, maxPoses: 1 });
    if (!poses || poses.length === 0) return null;
    const kps = poses[0].keypoints;
    // Map by name → indexed array matching COCO-17 (MoveNet already returns in COCO order).
    return kps.map((k) => ({ x: k.x, y: k.y, score: k.score }));
}
